// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-divider[data-v-3e056283] {\n  border-radius: 4px;\n  border-left: 0px;\n  border-right: 0px;\n  border-bottom: 0px;\n  border-top: 3px dashed var(--v-gray_50-base);\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
